document.addEventListener('DOMContentLoaded', function () {

  /* ── Helpers ── */
  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }
  function money(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── Cart drawer ── */
  var drawer = $('#cart-drawer');
  var overlay = $('#cart-overlay');

  function openDrawer() {
    drawer && drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Free shipping bar ── */
  function updateFreeShippingBar(cart) {
    var wrap = $('#cfs-wrap');
    var textEl = $('#cfs-text');
    var fillEl = $('#cfs-fill');
    if (!wrap || !textEl || !fillEl) return;
    if (!window.freeShippingEnabled) { wrap.style.display = 'none'; return; }

    var threshold = window.freeShippingThreshold || 3500;
    var total = cart.total_price;
    var pct = Math.min(100, Math.round(total / threshold * 100));

    fillEl.style.width = pct + '%';

    if (total >= threshold) {
      textEl.innerHTML = '🎉 <strong>You\'ve unlocked free shipping!</strong>';
      wrap.classList.add('is-unlocked');
    } else {
      var remaining = money(threshold - total);
      textEl.innerHTML = 'Spend <strong>' + remaining + ' more</strong> for free shipping';
      wrap.classList.remove('is-unlocked');
    }
  }

  function renderCart(cart) {
    var countEl = $('#cart-count');
    var subtotalEl = $('#cart-subtotal');
    var itemsEl = $('#cart-items');

    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(item) {
        return '<div class="cart-line">' +
          '<div class="cart-line-img">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-line-info">' +
            '<div class="cart-line-name">' + item.product_title + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line-meta">' + item.variant_title + '</div>' : '') +
            (item.selling_plan_allocation ? '<div class="cart-line-meta cart-line-sub">🔄 ' + item.selling_plan_allocation.selling_plan.name + '</div>' : '') +
            '<div class="cart-line-meta">' + money(item.price) + ' &times; ' + item.quantity + '</div>' +
          '</div>' +
          '<a href="/cart/change?line=' + (cart.items.indexOf(item) + 1) + '&quantity=0" class="cart-line-remove" aria-label="Remove">×</a>' +
        '</div>';
      }).join('');
    }

    updateFreeShippingBar(cart);
  }

  function fetchAndRender() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); return cart; });
  }

  /* Open cart */
  $$('[data-cart-open]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      fetchAndRender().then(openDrawer);
    });
  });

  /* Close cart */
  $$('[data-cart-close]').forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* Remove cart line */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-line-remove')) {
      e.preventDefault();
      var href = e.target.closest('.cart-line-remove').getAttribute('href');
      fetch(href).then(fetchAndRender);
    }
  });

  /* Add to cart — only fires for buttons NOT handled by product-detail inline script */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.dataset.pdHandled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetchAndRender(); })
    .then(openDrawer)
    .catch(function() { alert('Could not add to cart.'); })
    .finally(function() {
      btn.disabled = false;
      btn.textContent = orig;
    });
  });

  /* Cart upsell "Add" button — dedicated handler, does not rely on data-add-to-cart */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-upsell-btn');
    if (!btn) return;
    var upsellBlock = document.getElementById('cart-upsell-block');
    var id = upsellBlock ? parseInt(upsellBlock.getAttribute('data-variant-id')) : 0;
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetchAndRender(); })
    .then(openDrawer)
    .catch(function() {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  });

  /* Variant select */
  $$('[data-variant-select]').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var atcBtn = $('[data-add-to-cart]');
      if (atcBtn) atcBtn.setAttribute('data-variant-id', this.value);
    });
  });

  /* Header scroll shadow */
  var siteHeader = $('#site-header');
  if (siteHeader) {
    window.addEventListener('scroll', function() {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* Mobile menu */
  var menuBtn = $('.header-menu-btn');
  var mobileNav = $('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function() {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ── Image zoom lightbox ── */
  var zoomOverlay = $('#zoom-overlay');
  var zoomImg = $('#zoom-img');
  var zoomClose = $('#zoom-close');

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-zoom-src]');
    if (!trigger) return;
    var src = trigger.dataset.zoomSrc || trigger.src;
    if (!src || !zoomOverlay || !zoomImg) return;
    zoomImg.src = src;
    zoomOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  function closeZoom() {
    if (!zoomOverlay) return;
    zoomOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (zoomClose) zoomClose.addEventListener('click', closeZoom);
  if (zoomOverlay) zoomOverlay.addEventListener('click', function(e) {
    if (e.target === zoomOverlay) closeZoom();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeZoom();
  });

  /* ── Exit intent popup ── */
  var exitPopup = $('#exit-popup');
  var exitOverlay = $('#exit-popup-overlay');
  var exitClose = $('#exit-popup-close');
  var exitShown = false;
  var exitKey = 'exit-popup-seen';

  function openExitPopup() {
    if (!exitPopup || exitShown || sessionStorage.getItem(exitKey)) return;
    exitShown = true;
    exitPopup.classList.add('is-open');
    exitOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeExitPopup() {
    if (!exitPopup) return;
    exitPopup.classList.remove('is-open');
    exitOverlay && exitOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    sessionStorage.setItem(exitKey, '1');
  }

  if (exitClose) exitClose.addEventListener('click', closeExitPopup);
  if (exitOverlay) exitOverlay.addEventListener('click', closeExitPopup);

  var exitForm = $('#exit-popup-form');
  if (exitForm) {
    exitForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = exitForm.querySelector('input[type=email]');
      var email = input ? input.value.trim() : '';
      if (!email) return;

      /* Subscribe directly to Klaviyo — triggers welcome flow instantly */
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TztMfk', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: 'Yft8PF' }
              }
            }
          }
        })
      }).catch(function(){});

      exitForm.innerHTML = '<p style="font-size:1rem;font-weight:700;color:#22c55e;padding:16px 0;">🎉 Check your inbox for your discount!</p>';
      setTimeout(closeExitPopup, 2500);
    });
  }

  /* Trigger on mouse leaving viewport (desktop) */
  document.addEventListener('mouseleave', function(e) {
    if (e.clientY <= 10) openExitPopup();
  });

  /* Trigger on mobile after 45s of inactivity */
  var mobileExitTimer = setTimeout(function() {
    if (window.innerWidth < 769) openExitPopup();
  }, 45000);
  document.addEventListener('touchstart', function() {
    clearTimeout(mobileExitTimer);
    mobileExitTimer = setTimeout(function() {
      if (window.innerWidth < 769) openExitPopup();
    }, 45000);
  });

  /* ── Quick-add feedback ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pc-quick-add');
    if (!btn) return;
    e.preventDefault();
    var orig = btn.textContent;
    btn.textContent = 'Adding...';
    btn.classList.add('is-adding');
    var id = btn.dataset.variantId;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id), quantity: 1 })
    })
    .then(function() { return fetchAndRender(); })
    .then(function() {
      btn.textContent = 'Added ✓';
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      setTimeout(function() {
        btn.textContent = orig;
        btn.classList.remove('is-added');
        openDrawer();
      }, 1200);
    })
    .catch(function() {
      btn.textContent = orig;
      btn.classList.remove('is-adding');
    });
  });

  /* ── Social proof toasts ── */
  var spNames = [
    'Alex', 'Jamie', 'Sam', 'Jordan', 'Taylor', 'Morgan', 'Casey', 'Riley',
    'Charlie', 'Avery', 'Quinn', 'Blake', 'Drew', 'Hayden', 'Reese', 'Payton',
    'Elliot', 'Finley', 'Rowan', 'Sage', 'Liam', 'Noah', 'Oliver', 'Elijah',
    'Emma', 'Olivia', 'Ava', 'Sophia', 'Isabella', 'Mia', 'Jack', 'Harry'
  ];
  var spCities = [
    'London', 'Manchester', 'Birmingham', 'Leeds', 'Glasgow', 'Bristol',
    'Edinburgh', 'Liverpool', 'Sheffield', 'Newcastle', 'Nottingham', 'Cardiff',
    'Leicester', 'Brighton', 'Oxford', 'Cambridge', 'Bath', 'York', 'Exeter'
  ];
  var spToast = $('#sp-toast');
  var spIndex = 0;

  function showToast() {
    if (!spToast) return;
    var name = spNames[Math.floor(Math.random() * spNames.length)];
    var city = spCities[Math.floor(Math.random() * spCities.length)];
    var minsAgo = Math.floor(Math.random() * 25) + 2;
    spToast.innerHTML =
      '<div class="sp-toast-inner">' +
        '<span class="sp-toast-icon">🛒</span>' +
        '<div>' +
          '<strong>' + name + ' from ' + city + '</strong>' +
          '<span> just ordered</span>' +
          '<div class="sp-toast-time">' + minsAgo + ' minutes ago</div>' +
        '</div>' +
      '</div>';
    spToast.classList.add('is-visible');
    setTimeout(function() { spToast.classList.remove('is-visible'); }, 4500);
  }

  /* Only show on product pages */
  if (document.body.classList.contains('template-product') || document.querySelector('.pd-wrap')) {
    setTimeout(showToast, 6000);
    setInterval(showToast, 22000);
  }

  /* ── Viewers counter ── */
  var viewersEl = $('.pd-viewers-count');
  if (viewersEl) {
    var baseViewers = Math.floor(Math.random() * 14) + 7;
    viewersEl.textContent = baseViewers;
    setInterval(function() {
      var delta = Math.random() < 0.5 ? 1 : -1;
      baseViewers = Math.max(4, Math.min(28, baseViewers + delta));
      viewersEl.textContent = baseViewers;
    }, 8000);
  }

  /* ── Cart upsell ── */
  var upsellData = document.getElementById('cart-upsell-data');

  function renderUpsell(cart) {
    if (!upsellData) return;
    var variantId = upsellData.getAttribute('data-variant-id');
    if (!variantId) return;

    var drawerFt = $('.cart-drawer-ft');
    if (!drawerFt) return;

    // Only show when cart has items and upsell item is not already in cart
    if (cart.item_count === 0) {
      var existingUpsell = $('#cart-upsell-block');
      if (existingUpsell) existingUpsell.remove();
      return;
    }

    var alreadyInCart = cart.items.some(function(item) {
      return String(item.variant_id) === String(variantId);
    });
    if (alreadyInCart) {
      var existingUpsell = $('#cart-upsell-block');
      if (existingUpsell) existingUpsell.remove();
      return;
    }

    if ($('#cart-upsell-block')) return; // already rendered

    var title = upsellData.getAttribute('data-title') || '';
    var price = upsellData.getAttribute('data-price') || '';
    var image = upsellData.getAttribute('data-image') || '';

    var upsellBlock = document.createElement('div');
    upsellBlock.id = 'cart-upsell-block';
    upsellBlock.className = 'cart-upsell';
    upsellBlock.setAttribute('data-variant-id', variantId); // store for delegated handler

    // Build inner HTML without the button so we can attach a direct listener
    upsellBlock.innerHTML =
      '<p class="cart-upsell-label">You might also like</p>' +
      '<div class="cart-upsell-inner">' +
        (image ? '<img class="cart-upsell-img" src="' + image + '" alt="' + title + '" loading="lazy">' : '') +
        '<div class="cart-upsell-info">' +
          '<p class="cart-upsell-title">' + title + '</p>' +
          '<p class="cart-upsell-price">' + price + '</p>' +
        '</div>' +
      '</div>';

    // Create button separately so we can bind the event directly (more reliable than delegation)
    var upsellBtn = document.createElement('button');
    upsellBtn.className = 'cart-upsell-btn';
    upsellBtn.textContent = 'Add';
    upsellBtn.addEventListener('click', function() {
      upsellBtn.disabled = true;
      upsellBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Cart add failed');
        return fetchAndRender();
      })
      .then(function() {
        upsellBtn.textContent = 'Added ✓';
        setTimeout(openDrawer, 300);
      })
      .catch(function() {
        upsellBtn.disabled = false;
        upsellBtn.textContent = 'Add';
      });
    });

    upsellBlock.querySelector('.cart-upsell-inner').appendChild(upsellBtn);
    drawerFt.insertAdjacentElement('beforebegin', upsellBlock);
  }

  var origRenderCart = renderCart;
  renderCart = function(cart) {
    origRenderCart(cart);
    renderUpsell(cart);
  };

  /* Init on load */
  fetchAndRender();
});
